<div class="row mt-4">
  <div class="col-lg-9">
    <div class="row">
      <div class="col-3"></div>
      <div class="col-6">
        <h5 style="color: #92929f; text-align: center;;">Selected Chart Year</h5>
      </div>
      <div class="col-3"></div>
    </div>
    <div class="row">
      <div class="col-3"></div>
      <div class="col-6" style="text-align: center;">
        <kendo-dropdownlist
          [data]="chartYearsList"
          [(ngModel)]="selectedChartYear"
          [size]="'large'"
          (valueChange)="updateChartData()"
        ></kendo-dropdownlist>
      </div>
      <div class="col-3"></div>
    </div>
    <hr style="color: #92929f;"/>
    <div class="row">
      <div class="col-12">
        <highcharts-chart [ngStyle]="{display: selectedIndicationsCount < 8 ? 'block' : 'none'}"
          #container
          id="container"
          [Highcharts]="Highcharts"
          [options]="chartOptions"
          [(update)]="updateFlag"
          style="width: 100%; height: 900px; display: block;"
        ></highcharts-chart>
        <highcharts-chart [ngStyle]="{display: selectedIndicationsCount >= 8 ? 'block' : 'none'}"
          #pieContainer
          id="pieContainer"
          [Highcharts]="Highcharts"
          [options]="pieChartOptions"
          [(update)]="updateFlag"
          style="width: 100%; height: 900px; display: block;"
        ></highcharts-chart>
      </div>
      <!-- <div class="col-xxl-6">    
        <div id="chartdiv" [style.height]="this.selectedIndicationsCount >= 8 ? '1000px' : '650px'" style="width: 100%;"></div>
      </div>
      <div class="col-xxl-6">
        <div id="legenddiv" [style.height]="this.selectedIndicationsCount >= 8 ? '1000px' : '650px'" style="width: 100%;"></div>
      </div> -->
    </div>
  </div>
  <div class="col-lg-3"></div>
</div>
